import * as React from "react";
import { SVGProps } from "react";

const Omni = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 298 298" {...props}>
    <g fill="#1c347a">
      <path d="M298.93 149.46a149.52 149.52 0 0 1-149.46 149.38c-82.61 0-150-67.21-149.47-150.35C.54 65.87 67.93-.09 149.65 0c81 .09 149.1 65.61 149.28 149.46zm-39.7 0a110 110 0 0 0-109.5-109.85c-60.26-.17-110 48.88-110 109.68-.09 61 49.49 109.31 108.6 109.94a110.11 110.11 0 0 0 110.9-109.77z" />
      <path d="M236.85 12.32c16.56-.17 33.12-.17 49.68-.17V62a170.57 170.57 0 0 0-49.68-49.68zm49.68 224.53V287h-49.68a169.79 169.79 0 0 0 49.68-50.15zM62.09 12.37a168.59 168.59 0 0 0-49.94 49.5V12.46c1.06-.35 46.46-.46 49.94-.09zm-.22 274.34H12.46c-.35-1.16-.44-47.81-.09-49.86a169.49 169.49 0 0 0 49.5 49.86z" />
    </g>
  </svg>
);

export default Omni;
